import { UserApi } from '@entities/user/api/base';
import { API_USER_PREFIX } from '@shared/config/api/api-prefixes';
import { UsersDeleteDataResponse } from './user-delete-types';

export const userApi = UserApi.injectEndpoints({
    endpoints: (build) => ({
        userDelete: build.mutation<UsersDeleteDataResponse, number>({
            query: (id) => {
                return {
                    url: `${API_USER_PREFIX}/${id}`,
                    method: 'DELETE',
                };
            },
            invalidatesTags: ['UsersList'],
        }),
    }),
});

export const { useUserDeleteMutation } = userApi;
